import React, { createContext, useContext, useState, useEffect } from "react";

const DbContext = createContext();

// Create a provider component
export const DbProvider = ({ children }) => {
  const [dbCode, setDbCode] = useState(() => {
    // Retrieve dbCode from sessionStorage or fallback to localStorage
    const storedDbCode = sessionStorage.getItem("dbCode") || localStorage.getItem("dbCode");

    return storedDbCode || null;
  });

  useEffect(() => {
    if (dbCode) {
      sessionStorage.setItem("dbCode", dbCode);
      localStorage.setItem("dbCode", dbCode);
    }
  }, [dbCode]);

  return (
    <DbContext.Provider value={{ dbCode, setDbCode }}>
      {children}
    </DbContext.Provider>
  );
};

// Custom hook to use DbContext
export const useDbContext = () => {
  return useContext(DbContext);
};
